import React from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Kit de 30 Ideas de Contenido',
  desc: 'Un mes completo de publicaciones listo para usar. Títulos, captions y formatos para Instagram y Facebook adaptados a cualquier rubro.',
  value: '$9.990'
}, {
  title: 'Guía de Hashtags y Algoritmos 2025',
  desc: 'Cómo funciona el algoritmo de Instagram y Facebook hoy y qué estrategia de hashtags multiplica tu alcance orgánico sin gastar un peso.',
  value: '$9.990'
}, {
  title: 'Scripts de Venta para DMs',
  desc: '12 conversaciones modelo para responder consultas, manejar objeciones y cerrar ventas por mensaje directo. Copiás, pegás y vendés.',
  value: '$9.990'
}, {
  title: 'Checklist de Lanzamiento',
  desc: 'El paso a paso exacto para lanzar un producto en redes: desde la semana previa hasta el día del lanzamiento y el seguimiento post-venta.',
  value: '$9.990'
}];
export function Bonuses() {
  return <section className="py-20 bg-navy text-white px-4" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-18">
            4 Bonus Estratégicos incluidos gratis en el Megapack
          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto" data-id="element-19">
            Sin costo extra. Incluidos para que tengas todo lo que necesitás en
            un solo lugar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white/5 border border-white/10 rounded-2xl p-8 relative overflow-hidden" data-id="element-21">
              <div className="absolute top-0 right-0 bg-sky text-navy font-bold text-xs px-3 py-1 rounded-bl-lg" data-id="element-22">
                GRATIS
              </div>

              <div className="flex items-start gap-4 mb-4" data-id="element-23">
                <div className="bg-sky/20 p-3 rounded-lg text-sky" data-id="element-24">
                  <Gift className="w-6 h-6" data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <h3 className="text-xl font-bold mb-2" data-id="element-27">
                    Bonus {idx + 1}: {bonus.title}
                  </h3>
                  <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-28">
                    {bonus.desc}
                  </p>
                  <div className="flex items-center gap-3 text-sm" data-id="element-29">
                    <span className="text-slate-400 line-through" data-id="element-30">
                      Precio: {bonus.value}
                    </span>
                    <span className="text-sky font-bold" data-id="element-31">INCLUIDO</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-sky/10 border border-sky/30 rounded-xl p-6 text-center max-w-3xl mx-auto" data-id="element-32">
          <p className="text-xl md:text-2xl font-medium" data-id="element-33">
            Valor total de los 4 bonus por separado:{' '}
            <span className="line-through text-slate-400" data-id="element-34">$39.960</span>{' '}
            <span className="text-sky font-bold" data-id="element-35">→ GRATIS en el Megapack</span>
          </p>
        </div>
      </div>
    </section>;
}